import { Component, OnInit } from '@angular/core';
import {
  FieldArrayType,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms';

interface ArrayTypeProps extends FormlyFieldProps {
  summaryType: 'card' | 'table';
  addAnotherText: string;
  saveText: string;
  editText?: string;
  cancelText: string;
  saveChangesText: string;
  startEmpty?: boolean;
}

@Component({
    selector: 'lockton-apps-array-type',
    templateUrl: './array-type.component.html',
    standalone: false
})
export class ArrayTypeComponent
  extends FieldArrayType<FormlyFieldConfig<ArrayTypeProps>>
  implements OnInit
{
  isEditingExistingItem!: boolean;
  itemInEdit$ = new BehaviorSubject<number | undefined>(undefined);

  ngOnInit(): void {
    console.warn('This is still in development. USE CAREFULLY');
    if (!this.model && this.props.startEmpty) {
      this.add();
      this.itemInEdit$.next(0);
    }
  }

  onSaveClick() {
    if (!this.field.formControl?.valid) {
      this.showArrayFieldsError();
      return;
    }
    this.isEditingExistingItem = false;
    this.itemInEdit$.next(undefined);
  }

  showArrayFieldsError() {
    const formGroup = this.field.formControl as FormGroup;

    Object.values(formGroup.controls).forEach((controlGroup) => {
      const group = controlGroup as FormGroup;
      Object.values(group.controls).forEach((control) => {
        control?.markAsTouched();
        control?.updateValueAndValidity();
      });
    });
  }

  onAddAnotherClick() {
    this.add();
    this.itemInEdit$.next(this.model.length - 1);
  }

  onDeleteAt(i: number) {
    this.remove(i);
  }

  onCancelClick(index: number) {
    this.remove(index);
    this.itemInEdit$.next(undefined);
  }

  onEditAt(i: number) {
    this.isEditingExistingItem = true;
    this.itemInEdit$.next(i);
  }
}
